import styled from "styled-components";

export const CustomButtonsContainerStyled = styled.div`
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center
`;
